import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OverrideModule } from '@mandants/telekom/override/override.module';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { UserRoleAssignmentRow } from '../user-permissions.component';

export interface EndUserRoleDialogData {
  row: UserRoleAssignmentRow;
}

@Component({
  selector: 'app-end-user-role',
  templateUrl: './end-user-role.component.html',
  styleUrls: [],
  imports: [
    CommonModule,
    TranslateModule,
    SmartusComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    MatFormFieldModule,
    OverrideModule,
    MatDialogModule,
  ],
})
export class EndUserRoleComponent implements OnInit {
  form = new FormGroup({});

  formModel: any = {};

  formFields: FormlyFieldConfig[] = [
    {
      key: 'employeeInformation',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translateService.instant(
          'access_orderer_representative.dialog.employee'
        ),
        readOnly: true,
        valueFormatter: () => {
          return [this.data.row.username, this.data.row.email]
            .filter(Boolean)
            .join(', ');
        },
      },
    },
    {
      key: 'roleName',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translateService.instant(
          'user.request.permissions.assignment.table.role'
        ),
        readOnly: true,
      },
    },
    {
      key: 'validFrom',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translateService.instant(
          'user.request.permissions.assignment.table.validFrom'
        ),
        readOnly: true,
        valueFormatter: (validFrom: Date) => {
          if (!validFrom) {
            return '--';
          }
          return moment(validFrom)
            .locale(this.translateService.instant('locale.locale'))
            .format(
              this.translateService.instant('locale.moment__date_format')
            );
        },
      },
    },
    {
      key: 'validUntil',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translateService.instant(
          'user.request.permissions.assignment.table.validUntil'
        ),
        readOnly: true,
        valueFormatter: (validUntil: Date) => {
          if (!validUntil) {
            return '--';
          }
          return moment(validUntil)
            .locale(this.translateService.instant('locale.locale'))
            .format(
              this.translateService.instant('locale.moment__date_format')
            );
        },
      },
    },
  ];

  constructor(
    private translateService: TranslateService,
    public dialogRef: MatDialogRef<EndUserRoleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EndUserRoleDialogData
  ) {}

  ngOnInit() {
    this.formModel = this.data.row;
  }
}
